<template>
    <div class="main-bg">
      <el-form ref="form" :model="queryParams" :inline="true" size="small">
        <el-form-item label="手机号：" prop="userPhone">
          <el-input
            v-model="queryParams.userPhone"
           placeholder="请输入用户手机号"
            clearable
            @keyup.enter.native="handleQuery"
          />
        </el-form-item><el-form-item label="商户编码：" prop="merchantCoding">
          <el-input
            v-model="queryParams.merchantCoding"
           placeholder="请输入商户编码"
            clearable
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="用户状态：" prop="userStatus">
          <el-select v-model="queryParams.userStatus" clearable placeholder="请选择用户状态">
            <el-option
              v-for="item in userStatus"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付状态：" prop="paymentState">
          <el-select v-model="queryParams.paymentState" clearable placeholder="请选择支付状态">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!--<el-form-item label="注册日期：" prop="code">-->
          <!--<el-date-picker-->
            <!--v-model="queryParams.value"-->
            <!--type="daterange"-->
            <!--format="yyyy-MM-dd"-->
        <!--　　value-format="yyyy-MM-dd"-->
            <!--range-separator="至"-->
            <!--start-placeholder="开始日期"-->
            <!--end-placeholder="结束日期">-->
          <!--</el-date-picker>-->
        <!--</el-form-item>-->
        <!--<el-form-item label="结束日期：" prop="code">-->
          <!--<el-date-picker-->
            <!--v-model="queryParams.value"-->
            <!--type="daterange"-->
            <!--format="yyyy-MM-dd"-->
            <!--　　value-format="yyyy-MM-dd"-->
            <!--range-separator="至"-->
            <!--start-placeholder="开始日期"-->
            <!--end-placeholder="结束日期">-->
          <!--</el-date-picker>-->
        <!--</el-form-item>-->
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        </el-form-item>
      </el-form>
      <div class="container">
        <el-table
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column
            prop="userId"
            align="center"
            label="商户id">
          </el-table-column>
          <el-table-column
            prop="userName"
            align="center"
            label="商户名称">
          </el-table-column>
          <el-table-column
            prop="userPhone"
            align="center"
            label="手机号">
          </el-table-column>
          <el-table-column
            prop="merchantCoding"
            align="center"
            label="商户编码">
          </el-table-column>
          <el-table-column
            prop="userType"
            align="center"
            label="用户类型">
            <template slot-scope="scope">
              {{scope.row.userType==1901?'管理员':(scope.row.userType==1902?'普通用户':'超管')}}
            </template>
          </el-table-column>
          <el-table-column
            prop="userStatus"
            align="center"
            label="用户状态">
            <template slot-scope="scope">
              {{scope.row.userStatus==1002?'上架':'下架'}}
            </template>
          </el-table-column>
          <el-table-column
            prop="merchantCoding"
            align="center"
            label="支付状态">
            <template slot-scope="scope">
              {{scope.row.paymentState==0?'未支付':'已支付'}}
            </template>
          </el-table-column>
          <el-table-column
            prop="merchantCoding"
            align="center"
            label="注册时间">
            <template slot-scope="scope">
              <p>{{timestampToTime(scope.row.createTime)}}</p>
            </template>
          </el-table-column>
          <el-table-column
            prop="merchantCoding"
            align="center"
            label="到期时间">
            <template slot-scope="scope">
              <p>{{timestampToTime(scope.row.endTime)}}</p>
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            label="操作"
            width="300"
            fixed="right"
            align="center">
            <template slot-scope="scope">
              <!--<el-button-->
                <!--size="mini"-->
                <!--type="primary"-->
                <!--@click="handleDetail(scope.row)">查看</el-button>-->
                <el-button
                  size="mini"
                  type="primary"
                  v-if="scope.row.userType!=1902"
                  @click="handleedit(scope.row)">编辑</el-button>

              <el-button
                size="mini"
                type="primary"
                @click="handleBill(scope.row)">查询账单</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="pageNum"
          style="float: right;margin-top: 20px;"
          :page-size="10"
          background
          layout="total, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>
      <el-dialog title="编辑"  :visible.sync="editFlag" width="70%" append-to-body class="my-label">
          <el-form :model="ruleForm"  ref="ruleForm" label-width="140px" class="demo-ruleForm">
            <div class="titlebox">
              <div class="titlebar"></div>基础设置 <div class="titleline"></div>
            </div>
            <el-row>
              <el-col :span="12">
                <el-form-item label="商户id" prop="userId">
                  <el-input disabled v-model="ruleForm.userId"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="商户名称" prop="userName">
                  <el-input disabled v-model="ruleForm.userName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="手机号" prop="userPhone">
                  <el-input disabled v-model="ruleForm.userPhone"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="商户编码" prop="merchantCoding">
                  <el-input disabled v-model="ruleForm.merchantCoding"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="用户类型" prop="userType">
                  <el-input disabled v-model="ruleForm.userType"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="注册时间" prop="createTime">
                  <el-input disabled v-model="ruleForm.createTime"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="用户状态" prop="userType">
                  <el-select v-model="ruleForm.userStatus" placeholder="请选择" style="width:100%">
                  <el-option
                    v-for="item in userStatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="支付状态" prop="paymentState">
                  <el-select v-model="ruleForm.paymentState" placeholder="请选择" style="width:100%">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="到期时间" prop="endTime" >
                  <el-date-picker
                    v-model="ruleForm.endTime"
                    type="date"
                    style="width:100%"
                    placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <div class="titlebox">
                  <div class="titlebar"></div>打印机设置 <div class="titleline"></div>
                </div>
              </el-col>

            </el-row>
            <div style="text-align: right">
              <el-form-item>
                <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
                <el-button @click="editFlag=false">返 回</el-button>
              </el-form-item>
            </div>
          </el-form>

      </el-dialog>
      <el-dialog title="打印机配置"  :visible.sync="printFlag" width="70%" append-to-body class="my-label">
        <el-form :model="printForm" :rules="rules"   ref="printForm" label-width="140px" class="demo-ruleForm">
          <el-row>
            <el-col :span="12">
              <el-form-item label="是否开启打印机" prop="printStatus" >
                <el-radio-group v-model="printForm.printStatus">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="终端号" prop="printCode" >
                <el-input  v-model="printForm.printCode"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="密钥" prop="printKey" >
                <el-input  v-model="printForm.printKey"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="市场名" prop="marketName" >
                <el-input  v-model="printForm.marketName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="门店名" prop="radio" >
                <el-input  v-model="printForm.storeName"></el-input>
              </el-form-item>
            </el-col>
            <el-col  :span="12">
              <el-form-item label="小票打印联数" prop="printCopies" >
                <el-input type="number" v-model="printForm.printCopies"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="负责人姓名" prop="bossName" >
                <el-input  v-model="printForm.bossName"></el-input>
              </el-form-item>
            </el-col>
            <el-col  :span="12">
              <el-form-item label="负责人电话" prop="bossPhone" >
                <el-input type="number" v-model="printForm.bossPhone"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <div style="text-align: right">
            <el-button type="primary" @click="submitPrint('printForm')">确 定</el-button>
            <el-button @click="printFlag=false">返 回</el-button>
          </div>
        </el-form>
      </el-dialog>
    </div>
</template>

<script>
  import jsQR from "jsqr";
  import {getMerchantUserListPage,updateMerchantUser,getByMerchantCoding,editPrint} from '@/api/merchant'
  import {getCheckListPage} from '@/api/vegetableIncome'
    export default {
        name: "bill",
      data(){
          return{
            queryParams:{
              "userName": "", //商户名称(模糊)
              "merchantCoding": "", //商户号
              "userType": "", //用户类型(1901-管理员,1902-普通用户)
              "userStatus": "", //用户状态(1002-上架,1020-下架)
              "userPhone": "", //手机号
              "paymentState": "", //支付状态(0-未支付,1-已支付)
              "createStartStrTime": "", //结束时间(时间戳)
              "createEndStrTime": "" //结束时间(时间戳)
            },
            ruleForm:{},
            printForm:{},
            editFlag:false,
            printFlag:false,
            pageNum:1,
            total:0,
            form:{},
            checkFlag:false,
            tableData:[],
            fileList:[],
            incomeId:'',
            rules:{
              printStatus: [
                { required: true, message: '请选择是否开启打印机', trigger: 'change' }
              ],
              printCode: [
                { required: true, message: '请输入终端号', trigger: 'blur' }
              ],
              printKey: [
                { required: true, message: '请输入密钥', trigger: 'blur' }
              ],
              marketName: [
                { required: true, message: '请输入市场名', trigger: 'blur' }
              ],
              storeName: [
                { required: true, message: '请输入门店名', trigger: 'blur' }
              ],
              printCopies: [
                { required: true, message: '请输入小票打印联数', trigger: 'blur' }
              ],
              bossName: [
                { required: true, message: '请输入负责人姓名', trigger: 'blur' }
              ],
              bossPhone: [
                { required: true, message: '请输入负责人电话', trigger: 'blur' }
              ],
            },
            options: [{
              value: 0,
              label: '未支付'
            }, {
              value: 1,
              label: '已支付'
            }],
            userStatus: [{
              value: 1002,
              label: '上架'
            }, {
              value: 1020,
              label: '下架'
            }],
        }
      },
      mounted(){
          this.getList()
      },
      methods:{
        async printEdit(row){
          this.printFlag=true
          let body={
            merchantCoding:row.merchantCoding
          }
          let res = await getByMerchantCoding({body})
          this.printForm=res.body!=null?res.body:{}
        },
        async handleBill(row){
          let body={
            "pageSize": 30, //每页条数
            "pageNum": 1, //当前页
            table:{
              "merchantCoding": row.merchantCoding,


            }

          }

          let res = await getCheckListPage({body})

        },
        handleedit(row){
          this.editFlag=true
          this.ruleForm=row
          this.ruleForm.createTime=this.timestampToTime(row.createTime)
          this.ruleForm.userType=this.userType==1901?'管理员':'普通用户'
        },
        submitForm(formName) {
          this.$refs[formName].validate(async (valid) => {
            if (valid) {
              let body={
                userId:this.ruleForm.userId,
                userStatus:this.ruleForm.userStatus,
                endTime:this.ruleForm.endTime,
                paymentState:this.ruleForm.paymentState,

              }
              console.log(body)
              let res = await updateMerchantUser({body})
              this.$message({
                type: 'success',
                message: '修改成功!'
              });
              this.editFlag=false
              this.getList()
            } else {
              console.log('error submit!!');
              return false;
            }
          });
        },
        submitPrint(formName){
          this.$refs[formName].validate(async (valid) => {
            if (valid) {
              let body={
                  ...this.printForm

              }
              console.log(body)
              let res = await editPrint({body})
              this.$message({
                type: 'success',
                message: '修改成功!'
              });
              this.printFlag=false
              this.getList()
            } else {
              console.log('error submit!!');
              return false;
            }
          });
        },
        async getList(){
          var that=this
          let body={
            pageSize:10,
            pageNum:this.pageNum,
            table:{
              ...this.queryParams,
            }
          }
          let res = await getMerchantUserListPage({body})
          that.tableData=res.body.list
          that.total=res.body.totalCount
        },
        handleQuery(){
          this.pageNum=1
          this.getList()
        },
        handleDelete(row){
          var that=this
          this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let body={
              incomeId:row.incomeId
            }
            axios.post('api/vegetable_income/deleteIncome',{
              body
            }).then(function (res) {

                if (res.data.code==2000){
                  that.$message({
                    type: 'success',
                    message: '删除成功!'
                  });
                  that.getList()
                }else{
                  that.$message.error(res.data.msg);
                }
              }
            )

          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });


        },
        handleDetail(row){

          var that=this
          this.incomeId=row.incomeId
          let body={
            incomeId:row.incomeId
          }
          axios.post('api/vegetable_income/getIncomeById',{
            body
          }).then(function (res) {

              if (res.data.code==2000){
                that.form=res.data.body
                that.form.createTime=that.timestampToTime(that.form.createTime)

                that.checkFlag=true
              }else{
                that.$message.error(res.data.msg);
              }
            }
          )
        },
        timestampToTime(timestamp) {
          var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
          var Y = date.getFullYear() + '-';
          var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
          var D = date.getDate() + ' ';
          return Y+M+D;
        },
        handleCurrentChange(val){
          this.pageNum=val
          this.getList()
        }
      },
    }
</script>

<style scoped>
.titlebox{
  color:#20384D;
  font-size: 16px;
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}
  .titlebar{
    width: 4px;
    height: 16px;
    background: #035EBA;
    border-radius: 0 2px 2px 0;
    margin-right: 10px;
  }
  .titleline{
    flex: 1;
    height: 2px;
    background: #E6E9EE;
    margin-left: 20px;
  }
  .upload-tips{
    color: #999999;
    line-height: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/bill.vue